import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { from, map, switchMap, of } from 'rxjs';
import { SessionService } from '../session.service';

/**
 * Guard que verifica la autenticación del usuario.
 * Primero intenta validar la sesión directa (con renovación automática),
 * luego cae al flujo OIDC como fallback.
 */
export const authGuard: CanActivateFn = (route, state) => {
  const sessionService = inject(SessionService);
  const oidcSecurityService = inject(OidcSecurityService);
  const router = inject(Router);

  // Verificar sesión directa — getValidToken renueva si está expirado
  return from(sessionService.getValidToken()).pipe(
    switchMap((validToken) => {
      if (validToken) {
        return of(true);
      }

      // Fallback a OIDC
      return oidcSecurityService.checkAuth().pipe(
        map(({ isAuthenticated }) => {
          if (isAuthenticated) {
            return true;
          }
          router.navigate(['/login']);
          return false;
        })
      );
    })
  );
};
